import HttpClient from "./HttpClient";
import Order from "./Order";
import Comment from "./Comment.js";

export default class Operation {
    constructor(operation) {
        this.id = operation.id;
        this.amount = operation.amount;
        this.start_time = operation.start_time;
        this.end_time = operation.end_time;
        this.comment = operation.comment;
        this.status = operation.status;
        this.product_id = operation.product_id;
        this.work_center_id = operation.work_center_id;
        this.user_id = operation.user_id;
        this.created_at = operation.created_at;
        this.updated_at = operation.updated_at;
        this.comments = (() => {
            const comments = [];
            operation.comments.forEach(comment => {
                comments.push(new Comment(comment));
            });
            return comments;
        })();
    }

    static async loadOrderOperations(orders) {
        const client = new HttpClient();
        const orderIds = orders.map(e => { return e.id });
        const response = await client.instance.get("operations/orders", {
            params: {
                orders: orderIds
            }
        });
        const retrievedOrders = [];
        response.data.forEach(order => {
            retrievedOrders.push(new Order(order));
        });
        return retrievedOrders;
    }

    static async createOperation(data){
        const client = new HttpClient();
        const response = await client.instance.post("operations/add", data);
        return response.data;
    }

    static async createOperations(operations, endDate) {
        const client = new HttpClient();
        const response = await client.instance.post("operations", {
            operations: operations,
            end_date: endDate
        });
        return response.data;
    }

    async save() {
        const client = new HttpClient();
        const response = await client.instance.put(`operations/${this.id}`, this);
        return response.data;
    }

    async delete(){
        const client = new HttpClient();
        const response = await client.instance.delete(`operations/${this.id}`);
        return response.data;
    }

    static getOperations(products, centerId) {
        //determine class over here one check if order class, other if product
        let operations = [];
        for (const product of products) {
            operations = [...operations, ...product.getWorkCenterOperations(centerId)];
        }
        return operations.filter(operation => {
            return operation.status != 4;
        });
    }

    static getCompletedOperations(operations){
        return operations.filter(operation => {
            return operation.status == 2;
        });
    }

    static getFailedOperations(operations){
        return operations.filter(operation => {
            return operation.status == 3;
        });
    }

    static getCenterStyle(products, centerId) {
        const operations = Operation.getOperations(products, centerId);
        let completedOperations = Operation.getCompletedOperations(operations).length;
        const failedOperations = Operation.getFailedOperations(operations).length;
        if (failedOperations > 0) {
            return {
                "clickable": true,
                "failed-box": true
            };
        }
        if (operations.length == 0) {
            return {
                'empty-box': true
            }
        }
        if (completedOperations === operations.length) {
            return {
                "completed-box": true
            };
        } else {
            return {
                "uncompleted-box": true
            };
        }
    }
}